var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRmp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2549 986.5C2549 1259.6 2327.6 1481 2054.5 1481C1781.4 1481 1560 1259.6 1560 986.5C1560 713.395 1781.4 492 2054.5 492C2327.6 492 2549 713.395 2549 986.5ZM1609.45 986.5C1609.45 1232.29 1808.71 1431.55 2054.5 1431.55C2300.29 1431.55 2499.55 1232.29 2499.55 986.5C2499.55 740.706 2300.29 541.45 2054.5 541.45C1808.71 541.45 1609.45 740.706 1609.45 986.5Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2199.08 1459.39C2110.86 1486.36 2016.85 1488.12 1927.68 1464.46C1838.51 1440.8 1757.74 1392.67 1694.5 1325.51C1631.25 1258.35 1588.06 1174.84 1569.79 1084.41C1551.52 993.985 1558.92 900.252 1591.13 813.808L1637.47 831.077C1608.48 908.877 1601.82 993.236 1618.26 1074.62C1634.7 1156 1673.58 1231.17 1730.5 1291.61C1787.42 1352.06 1860.11 1395.37 1940.36 1416.67C2020.61 1437.96 2105.22 1436.38 2184.62 1412.1L2199.08 1459.39Z",
    fill: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2548.92 995.13C2547.1 1099.54 2512.27 1200.7 2449.43 1284.1C2386.58 1367.5 2298.94 1428.86 2199.08 1459.39L2184.62 1412.1C2274.5 1384.62 2353.37 1329.4 2409.93 1254.34C2466.49 1179.28 2497.84 1088.24 2499.48 994.267L2548.92 995.13Z",
    fill: "#F4F7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.82 817.371C1627.36 714.246 1698.13 626.537 1790.99 568.057C1883.86 509.578 1993.54 483.651 2102.75 494.36L2097.93 543.574C1999.63 533.936 1900.92 557.27 1817.34 609.902C1733.77 662.533 1670.07 741.471 1636.29 834.284L1589.82 817.371Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2097.6 493.882C2222.89 504.844 2339.31 563.138 2423.14 656.9C2506.97 750.662 2551.93 872.845 2548.85 998.582L2499.42 997.374C2502.18 884.21 2461.72 774.246 2386.27 689.86C2310.82 605.474 2206.06 553.009 2093.29 543.144L2097.6 493.882Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1202.62 451.489C1228.51 499.732 1225.43 622.105 1191.98 630.728C1178.64 634.166 1150.22 625.743 1121.3 608.311L1139.45 736.747H1032.26L1069.16 564.739C1048.58 540.582 1034.65 510.977 1036.98 477.804C1043.68 382.218 1176.74 403.246 1202.62 451.489Z",
    fill: "#EAC7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1212.75 473.151C1211.68 466.898 1209.09 459.953 1206.99 454.037C1204.29 446.41 1200.21 439.534 1195.71 433.053C1187.25 420.851 1177.1 409.833 1165.88 400.688C1145.41 383.984 1119.34 374.349 1093.71 377.478C1080.76 379.058 1068.2 383.995 1057.5 392.212C1047.84 399.637 1038.55 410.566 1026.04 411.351C1012.43 412.205 999.948 400.19 989.031 392.769C976.721 384.404 963.627 378.308 949.24 375.938C925.139 371.97 902.498 380.113 885.888 399.886C868.213 420.928 855.364 451.786 866.972 479.667C869.129 484.849 871.905 489.219 875.889 492.84C879.542 496.161 885.122 499.694 886.603 505C888.176 510.64 883.476 517.916 881.654 523.005C879.043 530.296 876.899 537.949 877.661 545.874C878.913 558.889 887.092 571.314 895.729 579.868C904.518 588.573 915.335 593.565 926.888 595.866C934.603 597.402 942.487 598.25 950.327 597.673C954.22 597.387 957.654 596.306 961.425 595.446C965.093 594.61 967.142 595.584 970.254 597.595C984.707 606.939 1000.25 610.554 1016.94 609.165C1031.02 607.992 1047.26 604.578 1058.75 594.927C1071.51 584.209 1071.26 569.428 1068.25 553.637C1071.43 555.213 1080.24 556.19 1074.98 549.905C1072.89 547.416 1068.96 546.403 1066.28 544.939C1063.17 543.235 1060.01 541.032 1057.59 538.251C1047.83 527.025 1057.69 504.177 1069.96 500.412C1088.18 494.818 1092.26 520.593 1105.27 527.261C1112.75 531.094 1120.58 525.854 1126.18 520.504C1133.69 513.337 1138.81 503.842 1143.23 494.18C1146.86 486.223 1150.25 478.154 1153.96 470.236C1155.69 466.539 1161.69 456.087 1158.68 451.906C1171.73 449.303 1186.27 454.728 1197.51 461.842C1202.16 464.783 1205.7 468.025 1208.18 473.217C1208.71 474.33 1209.87 477.637 1211.32 477.772C1214.02 478.025 1213.01 474.722 1212.75 473.151Z",
    fill: "#C93305"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.526 1107.47L1160.14 1671.26L1237.09 2094.56H1314.33L1237.23 1107.47H996.526Z",
    fill: "#EAC7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M996.526 1107.47L1160.14 1671.26L1237.09 2094.56H1314.33L1237.23 1107.47H996.526Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M923.001 1107.47C934.417 1400.35 929.915 1560.1 927.359 1586.71C924.804 1613.32 910.299 1791.54 811.454 2103.5H891.79C1022.69 1804.23 1068.39 1626.01 1083.4 1586.71C1098.42 1547.42 1142.76 1387.67 1207.5 1107.47H923.001Z",
    fill: "#EAC7A8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993.011 1107.47C1035.57 1301.47 1109.18 1611.15 1213.83 2036.5H1326.8C1335.15 1599.92 1299.65 1312.57 1238.18 1107.47H993.011Z",
    fill: "#56919C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M922.425 1107.47C933.606 1400.35 904.63 1688.9 814.874 2041.06H935.408C1066.55 1746.26 1160.55 1459.13 1224.79 1107.47H922.425Z",
    fill: "#89C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1588.59 845.765C1607.94 841.781 1655.18 806.651 1663.32 813.784C1675.36 824.336 1664.62 856.738 1651.97 872.856C1628.33 902.98 1608.75 913.282 1560.37 926.772C1535.08 933.825 1507.73 947.963 1478.32 969.185L1474.44 900.846L1542.54 863.436C1552.1 827.078 1563.52 808.784 1576.81 808.557C1587.02 803.807 1569.24 849.749 1588.59 845.765ZM1471.38 690.035C1458.88 712.228 1446.73 736.135 1453.1 742.972C1459.47 749.809 1475.35 740.258 1482.95 751.618C1488.02 759.192 1460.88 771.156 1401.54 787.51L1288.89 890.653L1231.64 829.205L1386.67 744.295C1412.45 713.68 1437.85 689.904 1462.87 672.965C1470.52 669.773 1483.89 667.841 1471.38 690.035Z",
    fill: "#DCAE92"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1136,
    y: 765,
    width: 256,
    height: 138
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1161.15 793.697C1214.88 801.625 1288.19 801.625 1372.18 765.271L1391.56 836.852C1330.65 880.755 1249.84 911.953 1185.41 899.885C1134.63 890.375 1118.34 824.557 1161.15 793.697Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1156.14 810.291C1210.44 809.717 1282.85 798.248 1360.12 749.204L1390.46 816.871C1337.16 869.762 1262.23 913.218 1196.7 911.378C1145.07 909.928 1118.68 847.469 1156.14 810.291Z",
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 868,
    y: 638,
    width: 699,
    height: 648
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1159.75 638.484C1166.59 726.335 1201.01 823.154 1229.25 918.804C1286.9 933.185 1383.57 916.231 1519.27 867.944C1552.93 937.577 1568.49 987.22 1565.95 1016.87C1449.53 1077.69 1349.74 1104.8 1267.54 1106.58C1270.18 1155.34 1264.25 1201.76 1244.3 1244.17C1203.3 1331.35 963.232 1250.61 882.512 1266.5C831.963 1102.34 929.701 1035.62 929.78 930.578C929.866 815.546 1022.23 638.484 1035.82 638.484H1159.75Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1159.75 638.484C1166.59 726.335 1201.01 823.154 1229.25 918.804C1286.9 933.185 1383.57 916.231 1519.27 867.944C1552.93 937.577 1568.49 987.22 1565.95 1016.87C1449.53 1077.69 1349.74 1104.8 1267.54 1106.58C1270.18 1155.34 1264.25 1201.76 1244.3 1244.17C1203.3 1331.35 963.232 1250.61 882.512 1266.5C831.963 1102.34 929.701 1035.62 929.78 930.578C929.866 815.546 1022.23 638.484 1035.82 638.484H1159.75Z",
    fill: "#ECECEC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmp);
export default __webpack_public_path__ + "static/media/rmp.875e6691bbe92646c7f3c3caeafdebb8.svg";
export { ForwardRef as ReactComponent };